/* ============================================================
   Jolene London — Bundle Selector JS
   ============================================================
   Handles:
   - Tier selection (visual state + hidden form quantity)
   - Live price recalculation when variant changes (size/colour swap)
   - Updates the Add to bag button price label
   ============================================================ */

(function () {
  'use strict';

  // ---- CONFIG (tweak here if you change discount tiers) ----
const TIERS = {
  1: { qty: 1, fixedPriceCents: null, label: '1 pair' },
  2: { qty: 2, fixedPriceCents: 2695, label: '2 pairs (20% off)' },
  3: { qty: 3, fixedPriceCents: 3390, label: '3 pairs (33% off)' },
};

  function formatMoney(cents) {
    const amount = (cents / 100).toFixed(2);
    if (window.Shopify && window.Shopify.formatMoney) {
      return window.Shopify.formatMoney(cents, window.theme?.moneyFormat || '£{{amount}}');
    }
    return '£' + amount;
  }

  function initBundle(root) {
    const options = root.querySelectorAll('.ao-bundle__option');
    const hiddenQty = root.querySelector('[data-bundle-quantity]');
    const hiddenTierProp = root.querySelector('[data-bundle-tier-prop]');

    let basePrice = parseInt(root.dataset.basePrice, 10);

    function recalcAndRender() {
      Object.keys(TIERS).forEach((tier) => {
        const t = TIERS[tier];
        const total = t.fixedPriceCents !== null ? t.fixedPriceCents : Math.round(basePrice * t.qty);
        const perPair = Math.round(total / t.qty);

        const priceEl = root.querySelector(`[data-price-display="${tier}"]`);
        const perPairEl = root.querySelector(`[data-per-pair-display="${tier}"]`);

        if (priceEl) priceEl.textContent = formatMoney(total);
        if (perPairEl && tier !== '1') perPairEl.textContent = formatMoney(perPair) + ' per pair';
      });
      updateAddToBagButton();
    }

    function selectTier(tierValue) {
      const tier = TIERS[tierValue];
      if (!tier) return;

      options.forEach((opt) => {
        const isSelected = opt.dataset.tier === String(tierValue);
        opt.classList.toggle('ao-bundle__option--selected', isSelected);
        const input = opt.querySelector('.ao-bundle__input');
        if (input) input.checked = isSelected;
      });

      if (hiddenQty) hiddenQty.value = tier.qty;
      if (hiddenTierProp) hiddenTierProp.value = tier.label;
      updateAddToBagButton();
    }

    function updateAddToBagButton() {
      const selected = root.querySelector('.ao-bundle__option--selected');
      if (!selected) return;
      const tier = TIERS[selected.dataset.tier];
      const total = Math.round(basePrice * tier.qty * tier.multiplier);

      const priceSlot = document.querySelector('[data-add-to-bag-price]');
      if (priceSlot) priceSlot.textContent = formatMoney(total);
    }

    options.forEach((opt) => {
      opt.addEventListener('click', (e) => {
        e.preventDefault();
        selectTier(opt.dataset.tier);
      });
    });

    // Listen for variant changes from the theme's variant picker
    document.addEventListener('variant:change', (e) => {
      const variant = e.detail?.variant;
      if (variant && variant.price) {
        basePrice = variant.price;
        root.dataset.basePrice = variant.price;
        recalcAndRender();
      }
    });

    // Fallback: listen to product-info element if present (Dawn theme)
    const productInfo = document.querySelector('product-info, product-form');
    if (productInfo) {
      productInfo.addEventListener('change', () => {
        const variantInput = productInfo.querySelector('[name="id"]');
        if (variantInput && window.ShopifyProductJSON) {
          const variant = window.ShopifyProductJSON.variants.find(
            (v) => String(v.id) === String(variantInput.value)
          );
          if (variant) {
            basePrice = variant.price;
            root.dataset.basePrice = variant.price;
            recalcAndRender();
          }
        }
      });
    }

    recalcAndRender();
  }

  function boot() {
    document.querySelectorAll('[data-bundle-selector]').forEach(initBundle);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
